export default 'production'